var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWAttach = function SvgWAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w-attach_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.222 3H4.778C3.79 3 3 3.791 3 4.778v12.444A1.778 1.778 0 0 0 4.778 19h12.444A1.778 1.778 0 0 0 19 17.222V4.778A1.778 1.778 0 0 0 17.222 3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.083 16.833h-1.75L11 8.083l-2.333 8.75h-1.75l-2.8-11.666H6.1l1.797 8.75 2.286-8.75h1.634l2.298 8.75 1.785-8.75h1.983M19.167.5H2.833A2.325 2.325 0 0 0 .5 2.833v16.334A2.333 2.333 0 0 0 2.833 21.5h16.334a2.333 2.333 0 0 0 2.333-2.333V2.833A2.333 2.333 0 0 0 19.167.5Z",
    fill: "#0037A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "w-attach_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgWAttach;